// 按模块的action, reducer整合体
const OPERATIONAL_STATIS = 'OPERATIONAL_STATIS';

export function getLocalOperationalStatis(params) {
  return dispatch => {
    return dispatch({
      type: OPERATIONAL_STATIS,
      data: params,
    });
  };
}

// Reducer
export function operationalStatis(
  state = {
    checkedUUids: [],
    data: [],
    wid: 1000,
    scrollLeft: 0,
    scrollTop: 0,
    org: [],
    type: [],
  },
  action,
) {
  switch (action.type) {
    case OPERATIONAL_STATIS:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/operational_statis.js